import { render } from "./ButtonRank120.vue?vue&type=template&id=33b92b76&scoped=true"
import script from "./ButtonRank120.vue?vue&type=script&lang=js"
export * from "./ButtonRank120.vue?vue&type=script&lang=js"

import "./ButtonRank120.vue?vue&type=style&index=0&id=33b92b76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b92b76"]])

export default __exports__